import React, { useState } from 'react';
import axios from 'axios';
import { User, Lock, ArrowRight, AlertCircle, CheckCircle } from 'lucide-react';
import { API_URL } from './api/client';

const Register = ({ setAuthView, darkMode }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (password !== confirmPassword) {
      setError('비밀번호가 일치하지 않습니다.');
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${API_URL}/register`, {
        username,
        password
      });
      alert('회원가입이 완료되었습니다. 로그인해주세요.');
      setAuthView('login');
    } catch (err) {
      console.error('Registration error:', err);
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError('회원가입에 실패했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundColor: darkMode ? '#1a1a1a' : '#f5f5f5',
      color: darkMode ? '#e0e0e0' : '#333',
      padding: '20px',
    },
    card: {
      width: '100%',
      maxWidth: '400px',
      backgroundColor: darkMode ? '#2d2d2d' : '#fff',
      borderRadius: '12px',
      boxShadow: darkMode ? '0 4px 6px rgba(0,0,0,0.3)' : '0 4px 6px rgba(0,0,0,0.1)',
      padding: '30px',
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      marginBottom: '30px',
      textAlign: 'center',
      color: darkMode ? '#fff' : '#333',
    },
    formGroup: {
      marginBottom: '20px',
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      fontSize: '14px',
      fontWeight: '500',
    },
    inputWrapper: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      position: 'absolute',
      left: '12px',
      color: '#888',
    },
    input: {
      width: '100%',
      padding: '12px 12px 12px 40px',
      borderRadius: '8px',
      border: `1px solid ${darkMode ? '#444' : '#ddd'}`,
      backgroundColor: darkMode ? '#3d3d3d' : '#fff',
      color: darkMode ? '#fff' : '#333',
      fontSize: '16px',
      outline: 'none',
      transition: 'border-color 0.2s',
    },
    button: {
      width: '100%',
      padding: '14px',
      backgroundColor: '#10b981',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      transition: 'background-color 0.2s',
      opacity: loading ? 0.7 : 1,
    },
    error: {
      backgroundColor: 'rgba(255, 77, 77, 0.1)',
      color: '#ff4d4d',
      padding: '12px',
      borderRadius: '8px',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      fontSize: '14px',
    },
    footer: {
      marginTop: '20px',
      textAlign: 'center',
      fontSize: '14px',
      color: darkMode ? '#aaa' : '#666',
    },
    link: {
      color: '#3b82f6',
      cursor: 'pointer',
      fontWeight: '500',
      marginLeft: '5px',
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>회원가입</h1>
        
        {error && (
          <div style={styles.error}>
            <AlertCircle size={18} />
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>아이디</label>
            <div style={styles.inputWrapper}>
              <User size={18} style={styles.icon} />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="아이디를 입력하세요"
                style={styles.input}
                required
              />
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>비밀번호</label>
            <div style={styles.inputWrapper}>
              <Lock size={18} style={styles.icon} />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="비밀번호를 입력하세요"
                style={styles.input}
                required
              />
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>비밀번호 확인</label>
            <div style={styles.inputWrapper}>
              <CheckCircle size={18} style={styles.icon} />
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="비밀번호를 다시 입력하세요"
                style={styles.input}
                required
              />
            </div>
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? '처리 중...' : '가입하기'}
            {!loading && <ArrowRight size={18} />}
          </button>
        </form>

        <div style={styles.footer}>
          이미 계정이 있으신가요?
          <span style={styles.link} onClick={() => setAuthView('login')}>
            로그인
          </span>
        </div>
      </div>
    </div>
  );
};

export default Register;
